import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import LoadingSpinner from './LoadingSpinner';
import { useDispatch, useSelector } from 'react-redux';

const AdminUserListTable = ({ userList = [], handleSelectedRow }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const loading = useSelector((state) => state.loading);

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDocuments, setFilteredDocuments] = useState(userList);
  const [selectedDocumentChecked, setSelectedDocumentChecked] = useState(null);

  useEffect(() => {
    setFilteredDocuments(userList);
  }, [userList]);

  const handleRowClick = (userId) => {
    handleSelectedRow(userId);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          disabled={loading}
        />
        <Tooltip title="Add New User">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
            disabled={loading}
          >
            User
          </Button>
        </Tooltip>
      </Box>

      <TableContainer
        sx={{
          maxHeight: 400,
          overflowY: 'auto',
          minHeight: 300,
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          borderRadius: 2,
          animation: 'fadeIn 0.4s forwards',
          '@keyframes fadeIn': {
            from: { opacity: 0 },
            to: { opacity: 1 },
          },
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              mt: 10,
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <LoadingSpinner size={30} />
          </Box>
        ) : (
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 'bold',
                    fontSize: 16,
                    backgroundColor: theme.palette.action.hover,
                  }}
                >
                  User
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 'bold',
                    fontSize: 16,
                    backgroundColor: theme.palette.action.hover,
                  }}
                >
                  Role
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 'bold',
                    fontSize: 16,
                    backgroundColor: theme.palette.action.hover,
                  }}
                >
                  Last Login
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(filteredDocuments) &&
                filteredDocuments.map((data, index) => (
                  <TableRow
                    key={index}
                    hover
                    onClick={() => handleRowClick(data.userId)}
                    sx={{
                      cursor: 'pointer',
                      backgroundColor:
                        selectedDocumentChecked === data
                          ? theme.palette.action.selected
                          : index % 2 === 0
                          ? theme.palette.background.default
                          : theme.palette.action.hover,
                      transition: 'background-color 0.2s ease',
                      '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                      },
                    }}
                  >
                    <TableCell>{data.firstname}</TableCell>
                    <TableCell>{data.role}</TableCell>
                    <TableCell>{data.email}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </Box>
  );
};

export default AdminUserListTable;
